import { OvFormInputReadOnly, OvSelect } from '@components'
import { useStore } from '@hooks/useStore'
import { IVatCode } from '@typings'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { IOvSelect } from '../ov-select/ov-select'

export type IOvVATFormInput = Omit<IOvSelect, 'options' | 'valueKey' | 'labelKey' | 'renderOption'>

export const OvVATFormInput = observer((props: IOvVATFormInput) => {
  const { shared } = useStore()
  const _readOnlyValue = shared.current_vat_codes.find(el => el['id'] === props.value)

  const {ref, ...rest} = props

  // Fetch VAT codes if not already fetched
  useEffect(() => {
    if (!shared.has_vat_codes) {
      shared.getVatCodes()
    }
  }, [shared])

  return props.disabled ? (
    <OvFormInputReadOnly
      {...rest}
      label={props.label}
      value={
        _readOnlyValue
          ? _readOnlyValue.name === 'BTW Verlegd'
            ? 'BTW verlegd'
            : `${_readOnlyValue.name} (${_readOnlyValue.percentage}%)`
          : ''
      }
    />
  ) : (
    <OvSelect
      {...props}
      options={shared.current_vat_codes as IVatCode[]}
      valueKey="id"
      labelKey="name"
      output="value"
      renderOption={value => (value.name === 'BTW Verlegd' ? 'BTW verlegd' : `${value.name} (${value.percentage}%)`)}
    />
  )
})
